import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutModule } from './layout/layout.module';
import { SharedModule } from './shared/modules/shared.module';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { reducers } from './shared/stores/reducers/reducers';
import { EffectsModule } from '@ngrx/effects';
import { AppEffects } from './shared/stores/effects/app.effects';
import { NgxSpinnerModule } from 'ngx-spinner';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpApiInterceptor } from './shared/interceptors/http-header.interceptor';
import { provideHotToastConfig } from '@ngxpert/hot-toast';
import { SubscriptionsManager } from './shared/helpers/subscriptions-manager';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    LayoutModule,
    SharedModule,
    StoreModule.forRoot(reducers),
    EffectsModule.forRoot(AppEffects),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),
    NgxSpinnerModule,
  ],
  providers: [
    provideAnimationsAsync('noop'),
    provideHotToastConfig({
      duration: 2000,
      position: 'top-right'
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpApiInterceptor,
      multi: true,
    },
    SubscriptionsManager
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
